import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=67260b8b&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67260b8b')) {
      api.createRecord('67260b8b', component.options)
    } else {
      api.reload('67260b8b', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=67260b8b&", function () {
      api.rerender('67260b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/comp/childrenage.vue"
export default component.exports